export enum ChangeEvent {
  Change = "change"
};

export enum RequestEvent {
  CurrentTranscriptionState = "CurrentTranscriptionState"
};

export const TranscriptionActionTypes = {
  ShareCurrentTranscriptionState: 'SHARE_CURRENT_TRANSCRIPTION_STATE'
}

export interface TranscriptionEvent extends Event {
  payload: any;
}
